import { Link } from "react-router";
import { css, styled } from "styled-components";

import { Image } from "common/components";
import { lineTruncationStyle } from "common/styles";
import type { Stakeholder } from "entities/stakeholders/types";

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const StyledContainer = styled.div`
  min-height: 195px;

  ${({ theme }) => css`
    background-color: ${theme.colors.backgroundPrimary};
  `};
`;

const StyledImage = styled(Image)`
  width: 100%;
  height: 120px;
`;

const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

const StyledText = styled.span`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.textFade};
  ${lineTruncationStyle(2)}
`;

const StyledTitle = styled.span`
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.textBright};
  ${lineTruncationStyle(2)}
`;

type StakeholderTileProps = { link: string; stakeholder: Stakeholder };

export const StakeholderTile = ({ stakeholder, link }: StakeholderTileProps) => (
  <StyledLink to={link}>
    <StyledContainer>
      <StyledImage src={stakeholder.images?.thumbnail} />
      <StyledInnerContainer>
        <StyledTitle>{stakeholder.full_name}</StyledTitle>
        <StyledText>{stakeholder.primary_organisation}</StyledText>
      </StyledInnerContainer>
    </StyledContainer>
  </StyledLink>
);
